import React, { useState, useEffect, useRef } from "react";
import { FiMoreVertical } from "react-icons/fi";

const groups = [
  { emoji: "🧒", name: "Kids", members: 15 },
  { emoji: "🚴‍♂️", name: "Sports team", members: 7 },
  { emoji: "🌳", name: "Outdoor", members: 7 },
];

const Groups = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenIndex(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="text-[#2F2F81] font-sans">
      {groups.map((group, index) => (
        <div
          key={index}
          className="flex items-center justify-between py-4 border-b relative"
        >
          <div className="flex items-center gap-3">
            <div className="text-2xl bg-gray-100 rounded-full p-1">{group.emoji}</div>
            <div>
              <div className="font-semibold text-sm dark:text-white">{group.name}</div>
              <div className="text-xs text-[#9CA3AF]">
                {group.members} members
              </div>
            </div>
          </div>

          <div className="relative" ref={dropdownRef}>
            <button
              className="p-2 text-[#9CA3AF] hover:text-[#2F2F81]"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <FiMoreVertical size={16} />
            </button>

            {openIndex === index && (
              <div className="absolute right-0 mt-2 bg-white border shadow-lg rounded-md text-sm p-2 z-20 text-[#2F2F81] w-40">
                <button className="w-full text-left hover:bg-gray-100 px-2 py-1 rounded">
                  Remove from group
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Groups;
